export default __webpack_public_path__ + "static/media/icollector_logo.5bd6a0c8.png";